import { render, staticRenderFns } from "./categorieArticle.vue?vue&type=template&id=932ed6be&scoped=true"
import script from "./categorieArticle.vue?vue&type=script&lang=js"
export * from "./categorieArticle.vue?vue&type=script&lang=js"
import style0 from "./categorieArticle.vue?vue&type=style&index=0&id=932ed6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932ed6be",
  null
  
)

export default component.exports